import Alert from "@storeblocks/alert";
import styled from "styled-components";

export const DowntimeAlertWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  padding: 16px 0;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
`;

export const AlertWithMargin = styled(Alert)`
  margin: 8px;
`;
